<div class="page-container">
  <div class="page-header">
    <div class="page-title">
      <mat-icon class="title-icon" [svgIcon]="'projects'"></mat-icon>
      <span>Projects</span>
      <button id="prj-add-project" mat-icon-button class="add-btn" (click)="createProject()" aria-label="Add Project">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="page-actions">
      <div class="date-filter">
        <mat-form-field id="prj-sort-by" appearance="outline" style="width: 180px; margin-left: 16px">
          <mat-select [(ngModel)]="sortBy" (selectionChange)="onSortOptionChange($event.value)">
            <mat-option
              *ngFor="let opt of projectSortOptions"
              [id]="'prj-sort-' + opt.key"
              [value]="opt.key"
              class="list-value"
            >
              {{ opt.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="date-filter">
        <mat-form-field id="prj-day-range" appearance="outline" style="width: 180px; margin-left: 16px">
          <mat-select [(ngModel)]="filterRange" (selectionChange)="onDateRangeChange($event.value)">
            <mat-option id="prj-day-range-30" [value]="30" class="list-value">Last 30 days</mat-option>
            <mat-option id="prj-day-range-60" [value]="60" class="list-value">Last 60 days</mat-option>
            <mat-option id="prj-day-range-90" [value]="90" class="list-value">Last 90 days</mat-option>
            <mat-option id="prj-day-range-0" [value]="0" class="list-value">All</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <app-project-search id="prj-search" (search)="onProjectSearchStr($event)"></app-project-search>
    </div>
  </div>

  <div class="error-state" *ngIf="viewState === 'error'" id="prj-error-state">
    <mat-icon id="prj-error-icon">error_outline</mat-icon>
    <span id="prj-error-message">{{ errorMessage }}</span>
  </div>

  <app-mobile-projects
    [projects]="projects"
    [filteredProjects]="filteredProjectList"
    [searchTerm]="searchTerm"
    [hasError]="viewState === 'error'"
    [errorMessage]="errorMessage"
    (search)="onProjectSearchStr($event)"
  >
  </app-mobile-projects>

  <div #projectsPageBody class="page-body" *ngIf="viewState === 'ready' || viewState === 'empty'">
    <table mat-table [dataSource]="dataSource" recycleRows class="projects-table">
      <!-- Project modified date column (unchanged) -->
      <!-- <ng-container matColumnDef="modifiedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="modifiedDate">Modified Date</th>
        <td mat-cell *matCellDef="let project">
          <span [innerHTML]="highlightDate(project.projectModifiedDate, searchTerm)"></span>
        </td>
      </ng-container> -->

      <!-- Project Column -->
      <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef>Project</th>
        <td mat-cell *matCellDef="let project" class="project-cell">
          <app-project-info-card
            [project]="project"
            [heading]="project.project_title || ''"
            [fromProject]="true"
            [searchTerm]="searchTerm"
            (editNoteClick)="onProjectEditNote($event)"
          >
          </app-project-info-card>
        </td>
      </ng-container>

      <!-- Products Column -->
      <ng-container matColumnDef="products">
        <th mat-header-cell *matHeaderCellDef>Products</th>
        <td mat-cell *matCellDef="let project" class="products-cell">
          <app-product-info-card
            [products]="getProjectProducts(project)"
            [experimentDevelopers]="getProjectExperimentDevelopers(project)"
            [experimentTags]="getProjectExperimentTags(project)"
            [fromProject]="true"
            [selectedProductIds]="getSelectedProductIds(project)"
            [selectedDeveloperIds]="getSelectedDeveloperIds(project)"
            [selectedTagIds]="getSelectedTagIds(project)"
            (productChipToggle)="onProjectProductToggle(project, $event)"
            (developerChipToggle)="onProjectDeveloperToggle(project, $event)"
            (tagChipToggle)="onProjectTagToggle(project, $event)"
            [searchTerm]="searchTerm"
          >
          </app-product-info-card>
        </td>
      </ng-container>

      <!-- Related Experiments Column -->
      <ng-container matColumnDef="experiments">
        <th mat-header-cell *matHeaderCellDef>Related Experiments</th>
        <td mat-cell *matCellDef="let project" class="experiments-cell">
          <app-related-experiments-accordion
            [experiments]="getFilteredProjectExperiments(project)"
            [header]="''"
            [disabled]="false"
            [fromProject]="true"
            [emptyMessage]="'No experiments available'"
            (experimentSelected)="onExperimentClick($event)"
            [searchTerm]="searchTerm"
          >
          </app-related-experiments-accordion>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [attr.id]="'prj-row-' + row.id_project"></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell"
          [attr.colspan]="displayedColumns.length"
          style="text-align: center; vertical-align: middle"
        >
          No Project data available
        </td>
      </tr>
    </table>
  </div>
</div>
